export default [
  { source: 'Oscar Wilde', text: 'Sois toi-même, les autres sont déjà pris.' },
  { source: 'Oscar Wilde', text: 'Pardonne toujours à tes ennemis; rien ne les ennuie autant.' },
  {
    source: 'Virginia Satir',
    text:
      'Nous ne devons pas permettre aux perceptions limitées des autres personnes de nous définir.'
  },
  {
    source: 'William Shakespeare',
    text:
      'Avant tout, sois loyal envers toi-même; et aussi infailliblement que la nuit suit le jour, tu ne pourras être déloyal envers personne.'
  },
  {
    source: 'Helen Keller',
    text: 'Je préfère marcher avec un ami dans l’obscurité que seul dans la lumière.'
  },
  {
    source: 'Winston Churchill',
    text:
      'Le courage, c’est ce qu’il faut pour se lever et parler; le courage est aussi ce qu’il faut pour s’asseoir et écouter.'
  },
  {
    source: 'Martin Luther King, Jr.',
    text: 'Le pardon n’est pas un acte occasionnel, mais une attitude permanente.'
  },
  { source: 'J.R.R. Tolkien', text: 'Le courage se trouve parfois dans des endroits inattendus.' },
  { source: 'J.R.R. Tolkien', text: 'Tant qu’il y a de la vie, il y a de l’espoir.' },
  {
    source: 'J.R.R. Tolkien',
    text: 'Ce n’est pas la force du corps qui compte, mais la force de l’esprit.'
  },
  {
    source: 'Dr. Seuss',
    text:
      'Soyez qui vous êtes et dites ce que vous ressentez, car ceux que ça dérange ne comptent pas et ceux qui comptent, cela ne les dérange pas.'
  },
  {
    source: 'Stephen King',
    text: 'L’humour est presque toujours la colère maquillée.'
  },
  {
    source: 'Abraham Lincoln',
    text: 'Aucun homme n’a assez de mémoire pour réussir dans le mensonge.'
  },
  { source: 'Mark Twain', text: 'Toutes les généralisations sont fausses y compris celle-ci. ' },
  { source: 'Ronald Reagan', text: 'Une image vaut mille refus.' },
  {
    source: 'Eleanor Roosevelt',
    text:
      'Les grands esprits discutent des idées; les esprits moyens discutent des événements; les petits esprits discutent des gens.'
  },
  {
    source: 'J.K. Rowling',
    text:
      'Ce sont nos choix, Harry, qui montrent ce que nous sommes vraiment, beaucoup plus que nos aptitudes.'
  },
  {
    source: 'Dax Shephard',
    text:
      'Le succès n’est qu’une guerre d’usure. Bien sûr, un peu de talent ne fait pas de mal. Mais quelque chose finira par arriver, si tu restes suffisament longtemps dans les parages. '
  },
  {
    source: 'Katherine Hepburn',
    text: 'Si vous faites toujours ce qui vous intéresse, au moins une personne est satisfaite.'
  },
  {
    source: 'Wilma Rudolph',
    text:
      'Ne sous-estimez pas la puissance des rêves et l’influence de l’esprit humain. Nous sommes tous pareils dans ce concept: Le potentiel pour la grandeur vit en chacun de nous.'
  },
  {
    source: 'François de La Rochefoucauld',
    text: 'Pour atteindre la grandeur, il faut vivre comme s’il n’y avait pas de lendemain.'
  },
  {
    source: 'Edmund Hillary',
    text:
      'Les gens ne décident pas de devenir extraordinaires. Ils décident d’accomplir des choses extraordinaires.'
  },
  {
    source: 'Albert Einstein',
    text: 'Toute personne qui n’a jamais commis d’erreur n’a jamais tenté d’innover.'
  },
  {
    source: 'James Dean',
    text: 'Puisqu’on ne peut changer la direction du vent, il faut apprendre à orienter les voiles.'
  },
  {
    source: 'Nelson Mandela',
    text: 'Un gagnant est un rêveur qui n’abandonne jamais.'
  },
  {
    source: 'Eleanor Roosevelt',
    text: 'Personne ne peut vous diminuer sans que vous y consentiez.'
  },
  {
    source: 'Henry Ford',
    text:
      'Que vous pensiez pouvoir accomplir une tâche ou ne pas pouvoir l’accomplir, vous avez dans les deux cas raison.'
  },
  {
    source: 'Alice Walker',
    text:
      'La manière la plus courante que les gens abandonnent leur pouvoir est de penser qu’ils n’en ont pas.'
  },
  {
    source: 'Oprah Winfrey',
    text:
      'Soyez reconnaissant pour ce que vous avez; vous finirez par avoir plus. Si vous vous concentrez sur ce que vous n’avez pas, vous n’en aurez jamais assez.'
  },
  {
    source: 'Helen Keller',
    text:
      'Lorsqu’une porte du bonheur se ferme, une autre s’ouvre; mais parfois on observe si longtemps celle qui est fermée qu’on ne voit pas celle qui vient de s’ouvrir à nous.'
  },
  {
    source: 'George Adair',
    text: 'Tout ce que vous avez toujours voulu se trouve au-delà de votre peur.'
  },
  {
    source: 'Amelia Earhart',
    text: 'Le plus difficile c’est de se décider à agir, le reste n’est que de la ténacité.'
  },
  {
    source: 'George Whitefield',
    text:
      'Avancez. Ne vous arrêtez pas, ne vous attardez pas durant votre voyage, mais efforcez-vous d’atteindre la ligne d’arrivée.'
  },
  {
    source: 'Charles Swindoll',
    text:
      'La vie, c’est dix pour cent ce que vous en faites et quatre-vingt-dix pour cent votre façon de la prendre.'
  },
  {
    source: 'Michael Phelps',
    text:
      'Il y aura des obstacles. Il y aura des sceptiques. Il y aura des erreurs. Mais avec un travail acharné, il n’y a pas de limites.'
  },
  {
    source: 'Babe Ruth',
    text: 'Il est difficile de vaincre une personne qui n’abandonne jamais.'
  },
  {
    source: 'Thomas Edison',
    text:
      'La plupart des échecs dans la vie viennent des personnes qui n’ont pas réalisé à quel point elles étaient proches du succès lorsqu’elles ont abandonné.'
  },
  {
    source: 'Aristotle Onassis',
    text:
      'C’est pendant nos moments les plus sombres que nous devons nous concentrer pour voir la lumière.'
  },
  {
    source: 'Eleanor Roosevelt',
    text: 'Avec le jour nouveau viennent des forces et des pensées neuves.'
  },
  {
    source: 'Robert Louis Stevenson',
    text: 'Ne juge pas chaque jour à la récolte que tu fais mais aux graines que tu sèmes.'
  },
  {
    source: 'Vincent Van Gogh',
    text:
      'Si vous entendez une voix en vous dire:« Vous ne pouvez pas peindre », alors certainement peignez et cette voix sera réduite au silence.'
  },
  {
    source: 'Roy T. Bennett',
    text:
      'Ne soyez pas bousculé par les peurs dans votre esprit. Laissez-vous guider par les rêves de votre coeur.'
  },
  {
    source: 'Mark Cuban',
    text:
      'Toujours se réveiller avec un sourire sachant que, aujourd’hui, vous allez avoir du plaisir en accomplissant ce que les autres ont trop peur de le faire.'
  },
  {
    source: 'Maya Angelou',
    text:
      'Fais tout ton possible pour changer les choses qui te déplaisent et si tu ne peux opérer aucun changement, change ta façon de les appréhender.'
  },
  {
    source: 'Jesse Owens',
    text:
      'Le bien est tout autour de vous. Trouvez-le, mettez-le en valeur et vous commencerez à y croire.'
  },
  {
    source: 'Audre Lorde',
    text:
      'Si je ne me définissais pas pour moi-même, je serais croquée dans les fantasmes des autres et mangée vivante. '
  },
  {
    source: 'Viola Davis',
    text:
      'Je n’ai pas le temps à rester éveillée toute la nuit et réfléchir sur ce qu’une personne qui ne m’aime pas a à dire sur moi.'
  },
  {
    source: 'Frederick Douglass',
    text:
      'J’ai prié pendant vingt ans, mais je n’ai reçu aucune réponse jusqu’à ce que j’ai prié avec mes jambes.'
  },
  {
    source: 'Barack Obama ',
    text:
      'Le changement ne viendra pas si nous attendons une autre personne ou une autre fois. Nous sommes ceux que nous attendions. Nous sommes le changement que nous recherchons.'
  },
  {
    source: 'James Baldwin',
    text:
      'Il n’y a jamais de temps dans le futur où nous travaillerons à notre salut. Le défi est dans le moment; le temps est toujours maintenant.'
  },
  {
    source: 'Dr. Martin Luther King, Jr.',
    text:
      'Si vous ne pouvez pas voler, alors courez; Si vous ne pouvez pas courir, alors marchez; Si vous ne pouvez pas marcher, alors rampez; Mais quoi que vous fassiez, vous devez continuer à avancer.'
  },
  {
    source: 'Dr. Mae Jamison',
    text: 'Ne soyez jamais limité par l’imagination limitée des autres.'
  },
  {
    source: 'Phylicia Rashad',
    text:
      'Il y a toujours quelque chose qui suggère que vous ne serez jamais qui vous vouliez être. Votre choix est de l’accepter ou de continuer à vous transformer.'
  },
  {
    source: 'Beyoncé Knowles',
    text: 'Le pouvoir ne te sera pas donné. Tu dois le prendre.'
  },
  {
    source: 'Arthur Ashe',
    text:
      'Une des clés du succès est la confiance en soi. Une des clés de la confiance en soi est la préparation.'
  },
  {
    source: 'Frank Sinatra',
    text: 'La meilleure vengeance est un succès immense.'
  },
  {
    source: 'J.K. Rowling',
    text:
      'Always wake up with a smile knowing that today you are going to have fun accomplishing what others are too afraid to do.'
  },
  {
    source: 'Steve Jobs',
    text:
      'Votre temps est limité, ne le perdez pas à vouloir vivre la vie de quelqu’un de différent.'
  },
  {
    source: 'Zig Ziglar',
    text:
      'Les gens disent souvent que la motivation ne dure pas. Eh bien, la propreté après un bain non plus - c’est pourquoi nous le recommandons quotidiennement.'
  },
  {
    source: 'Jim Rohn',
    text: 'Vous êtes la moyenne des cinq personnes avec lesquelles vous passez le plus de temps.'
  },
  {
    source: 'Vince Lombardi',
    text:
      'La différence entre une personne qui réussit et les autres n’est pas un manque de force, pas un manque de connaissances, mais plutôt un manque de volonté.'
  },
  {
    source: 'Bruce Lee',
    text:
      'Si vous aimez la vie, ne perdez pas de temps, car le temps est ce dont se compose la vie.'
  },
  {
    source: 'Abraham Lincoln',
    text:
      'Les choses peuvent venir à ceux qui attendent, mais uniquement les choses laissées par ceux qui agissent.'
  },
  {
    source: 'John Lennon',
    text: 'La vie, c’est ce qui arrive quand on est occupé à faire d’autres projets.'
  },
  {
    source: 'Angelica Monroy',
    text: 'Embrassez vos vulnérabilités, acceptez-les et pardonnez-vous.'
  },
  {
    source: 'Iris Soto',
    text:
      'Face aux défis difficiles, rappelez-vous que ce sont des bénédictions déguisées, traversez-les avec foi.'
  },
  {
    source: 'Carlos Santana',
    text:
      'L’atout le plus précieux que vous pouvez posséder est un cœur ouvert. L’arme la plus puissante peut être un instrument de paix.'
  },
  {
    source: 'Cesar Chavez ',
    text:
      'La préservation de sa propre culture n’exige pas de mépris ou de manque de respect pour les autres cultures.'
  },
  {
    source: 'Gwendolyn Brooks',
    text:
      'Ne laissez personne vous appeler minorité si vous êtes noir ou hispanique ou si vous appartenez à un autre groupe ethnique. Vous n’êtes pas moins que quiconque.'
  },
  {
    source: 'Dolly Parton ',
    text: 'Si tu veux voir l’arc-en-ciel, tu dois accepter la pluie. '
  },
  {
    source: 'Dr. Seuss',
    text:
      'Parfois, vous ne connaîtrez jamais la valeur d’un moment, jusqu’à ce qu’il devienne un souvenir.'
  },
  {
    source: 'C.S. Lewis',
    text: 'Vous n’êtes jamais trop vieux pour définir un autre but ou rêver à de nouveaux projets.'
  },
  {
    source: 'Helen Keller',
    text:
      'Ne baissez jamais la tête. Tenez-la toujours élevée. Regardez le monde droit dans les yeux.'
  },
  {
    source: 'Theodore Roosevelt',
    text: 'Croyez que vous pouvez le faire et vous aurez déjà fait la moitié du chemin.'
  },
  {
    source: 'Carol Burnett',
    text: 'Quand on a un rêve, il faut s’y accrocher et ne jamais le lâcher.'
  },
  {
    source: 'Albert Einstein',
    text: 'La vie, c’est comme une bicyclette, il faut avancer pour ne pas perdre l’équilibre.'
  },
  {
    source: 'Ella Fitzgerald',
    text:
      'Ne renoncez pas à faire ce que vous voulez vraiment faire. Là où il y a des rêves, de l’amour et de l’inspiration, vous ne pourrez pas vous tromper.'
  },
  {
    source: 'Amy Poehler',
    text: 'Limitez votre "toujours" et vos "jamais".'
  },
  {
    source: 'Maya Angelou',
    text: 'Essaie d’être un arc-en-ciel dans le nuage d’autrui.'
  },
  {
    source: '"Camilla Eyring Kimball',
    text: 'Vous ne trouvez pas que votre vie est heureuse. Rendez-la heureuse.'
  },
  {
    source: 'E.E. Cummings',
    text: 'La plus perdue de toutes les journées est celle où l’on n’a pas ri.'
  },
  {
    source: 'George Eliot',
    text: 'Il n’est jamais trop tard pour devenir ce que nous aurions pu être.'
  },
  {
    source: 'Hazrat Inayat Khan',
    text: 'Certaines personnes cherchent un bel endroit. D’autres rendent un endroit magnifique.'
  },
  {
    source: 'Lindsey Von',
    text: 'La vie change très rapidement, de manière très positive, si vous la laissez faire.'
  },
  {
    source: 'Malala Yousafzai',
    text: 'Je suis persuadée que les rêves d’aujourd’hui seront les réalités de demain.'
  },
  {
    source: 'Mandy Hale',
    text:
      'Vous n’avez pas toujours besoin d’un plan. Parfois, vous avez juste besoin de respirer, de faire confiance, de lâcher prise et de voir ce qui se passe.'
  },
  {
    source: 'Meghan Markle',
    text:
      'Vous ne pouvez être que ce que vous êtes. Détendez-vous ! L’existence a besoin de vous tel que vous êtes.'
  },
  {
    source: 'Martin Luther King Jr.',
    text:
      'Si vous ne pouvez pas faire de grandes choses, faites de petites choses de façon grandioses.'
  },
  {
    source: 'Nicole Kidman',
    text: 'Plus vous louez et célébrez votre vie, plus il y a de vie à célébrer.'
  },
  {
    source: 'Oprah Winfrey',
    text: 'Plus vous louez et célébrez votre vie, plus il y a de vie à célébrer.'
  },
  {
    source: 'Reese Witherspoon',
    text: 'Avec le bon type de coaching et de détermination vous pouvez accomplir quoi que ce soit.'
  },
  {
    source: 'Roald Dahl',
    text:
      'Si vous avez de bonnes pensées, elles brilleront sur votre visage comme des rayons de soleil et vous serez toujours magnifique.'
  },
  {
    source: 'Robin Williams',
    text: 'Peu importe ce que les gens vous disent, les mots et les idées peuvent changer le monde.'
  },
  {
    source: 'Rosa Parks',
    text: 'On doit vivre sa vie en essayant d’en faire un modèle pour d’autres.'
  },
  {
    source: 'Serena Williams',
    text:
      'Une championne ne se définit pas par ses victoires, mais par la façon dont elle se relève lorsqu’elle tombe.'
  },
  {
    source: 'Sheryl Sandberg',
    text: 'La motivation surgit lorsqu’on travail sur des choses qui nous tiennent à coeur.'
  },
  {
    source: 'Walt Whitman',
    text: 'Gardez votre visage toujours vers le soleil - et les ombres tomberont derrière vous.'
  },
  {
    source: 'John Bunyan',
    text:
      'Vous n’avez pas vécu aujourd’hui avant d’avoir fait quelque chose pour quelqu’un qui ne pourra jamais vous rendre la pareille.'
  },
  {
    source: 'Walt Whitman',
    text: 'Chaque instant de lumière et d’obscurité est un miracle.'
  },
  {
    source: 'Will Rogers',
    text:
      'Même si vous êtes sur la bonne voie, vous allez vous faire écraser si vous restez assis là.'
  },
  {
    source: 'Mark Zuckerberg',
    text:
      'Le plus grand risque est de ne pas prendre de risque… Dans un monde qui évolue très rapidement, la seule stratégie qui est sûre d’échouer est de ne pas prendre de risques. '
  },
  {
    source: 'Napolean Hill',
    text: 'Tout ce que l’esprit peut concevoir et croire, il peut aussi l’obtenir.'
  },
  {
    source: 'Ted Murphy',
    text: 'Si ce n’est pas un peu effrayant, cela ne vaut probablement pas la peine.'
  },
  {
    source: 'Sydney Harris',
    text:
      'Quand j’entends quelqu’un soupirer et dire que la vie est difficile, je suis toujours tenté de demander : "Comparé à quoi ?"'
  },
  {
    source: 'Arthur Schopenhauer',
    text:
      'Toute vérité franchit trois étapes : D’abord, elle est ridiculisée. Ensuite, elle subit une forte opposition. Puis, elle est considérée comme ayant toujours été une évidence.'
  },
  {
    source: 'John F. Kennedy',
    text: 'Si ce n’est pas nous, alors qui ? Si pas maintenant, alors quand ?'
  },
  {
    source: 'Jack Canfield ',
    text:
      'Ne t’inquiète pas de l’échec, inquiète-toi des chances que tu manques lorsque tu n’essaies même pas.'
  },
  {
    source: 'Sir Claus Moser',
    text: 'Si vous trouvez que l’éducation coûte cher, essayez l’ignorance.'
  },
  {
    source: 'John Wooden',
    text:
      'Ne laissez pas les choses que vous êtes incapable de faire, nuire à celles que vous pouvez accomplir.'
  },
  {
    source: 'Babe Ruth',
    text: 'Chaque balle frappée, me rapproche du prochain coup de circuit.'
  },
  {
    source: 'Dr. Martin Luther King Jr.',
    text:
      'Nos vies commencent à finir le jour où nous devenons silencieux à propos des choses qui comptent.'
  },
  {
    source: 'Maya Angelou',
    text:
      'Le préjugé est un fardeau qui obscurcit le passé, qui menace l’avenir et qui rend le présent inaccessible.'
  },
  {
    source: 'Rosa Parks',
    text:
      'Pour apporter des changements, il ne faut pas avoir peur de faire le premier pas. Nous échouerons si nous n’essayons pas.'
  },
  {
    source: 'James Baldwin',
    text:
      'On ne peut pas changer tout ce que l’on affronte mais rien ne peut changer tant qu’on ne l’affronte pas.'
  },
  {
    source: 'Dr. Martin Luther King Jr.',
    text:
      'L’obscurité ne peut pas chasser l’obscurité; seule la lumière le peut. La haine ne peut pas chasser la haine; seul l’amour le peut.'
  },
  {
    source: 'Malcolm X',
    text: 'Un homme qui ne défend aucune cause, tombera au nom de n’importe quoi.'
  },
  {
    source: 'Malcolm X',
    text:
      'Paix et liberté ne peuvent être séparées, car personne ne peut être en paix tant qu’il n’est pas libre.'
  },
  {
    source: 'Andrew Hendrixson',
    text: 'Quiconque a déjà fait quelque chose d’important était discipliné.'
  },
  {
    source: 'Coco Chanel',
    text: 'Ne perdez pas votre temps à frapper un mur, espérant le transformer en une porte.'
  },
  {
    source: 'Albert Einstein',
    text: 'La créativité, c’est l’intelligence qui s’amuse.'
  },
  {
    source: 'Grace Coddington',
    text:
      'Gardez toujours les yeux ouverts. Continuer d’observer. Parce que tout ce que vous voyez peut vous inspirer.'
  },
  {
    source: 'Henry David Thoreau',
    text:
      'Ce qu’on obtient en atteignant nos objectifs n’est pas aussi important que ce que l’on devient en les atteignant.'
  },
  {
    source: 'Seth Godin',
    text:
      'Au lieu de vous demander quand seront vos prochaines vacances, peut-être que vous devriez construire une vie dans laquelle vous n’avez pas besoin de vous échapper.'
  },
  {
    source: 'John Maxwell',
    text: 'Parfois on gagne, parfois on apprend.'
  },
  {
    source: 'Audre Lorde',
    text:
      'Prendre soin de soi n’est pas de l’égocentrisme, c’est de l’auto-préservation, et c’est un acte de combat politique.'
  },
  {
    source: 'Assata Shakur',
    text: 'Les rêves et la réalité sont opposés. L’action les synthétise.'
  },
  {
    source: 'Wangari Maathai',
    text: 'Chaque arbre est le symbole vivant de la paix et de l’espoir.'
  },
  {
    source: 'Rev. Peter Marshall',
    text:
      'Pouvons-nous penser à la liberté, non pas comme le droit de faire ce que nous voulons, mais comme l’opportunité de faire ce qui est juste.'
  },
  {
    source: 'Martha Grimes',
    text:
      'On cherche du réconfort partout autour de soi, mais il n’y en a pas; il n’y en a jamais eu, et il n’y en aura probablement jamais.'
  },
  {
    source: 'Vidal Sassoon ',
    text: 'Le seul lieu où le "succès" précède le "travail" est le dictionnaire.'
  },
  {
    source: 'Adelaide Anne Procter',
    text:
      '"Aucune étoile n’est jamais perdue que nous ayons vue une fois, Nous pouvons toujours être ce que nous aurions pu être."'
  },
  {
    source: 'George Patton',
    text:
      'Ne dites jamais aux gens comment faire les choses. Dites-leur ce qu’il faut faire, et ils vous surprendront par leur ingéniosité.'
  },
  {
    source: 'Robert Frost ',
    text:
      'La plupart des changements que nous croyons observer au cours de notre vie sont dus à l’alternance de la faveur ou de la disgrâce de vérités.'
  },
  {
    source: 'Bob Black',
    text:
      'Vous êtes ce que vous faites. Si vous faites un travail ennuyeux, stupide et monotone, il y a de fortes chances que vous finissiez par être ennuyeux, stupide et monotone.'
  },
  {
    source: 'Georg Wilhelm Friedrich Hegel',
    text: 'Rien de grand ne s’est accompli dans le monde sans passion.'
  },
  {
    source: 'Friedrich Nietzsche',
    text:
      'Il n’existe au monde qu’un seul chemin sur lequel nul autre que toi ne peut passer. Où mène-t-il? Ne te le demande pas. Suis-le.'
  },
  {
    source: 'Pablo Picasso ',
    text: 'L’art est un mensonge qui nous permet de dévoiler la vérité.'
  },
  {
    source: 'Henry David Thoreau',
    text:
      'La vie m’a enseigné au moins une chose : si quelqu’un avance avec confiance en direction de ses rêves et qu’il s’efforce de mener l’existence qu’il a imaginée, il jouira d’une réussite hors du commun.'
  },
  {
    source: 'Bob Dylan',
    text:
      'Il n’est dans l’intérêt de personne de réfléchir à la manière dont ils seront perçus demain. Cela fait mal à long terme.'
  },
  {
    source: 'Stephen Vincent Benet',
    text:
      'La vie ne se perd pas en mourant; la vie se perd minute par minute, jour après jour, de toutes les mille petites manières insouciantes.'
  },
  {
    source: 'Mary Shelley',
    text: 'Rien n’est plus douloureux pour l’esprit humain qu’un changement profond et soudain.'
  },
  {
    source: 'E.M. Forster',
    text: 'Soit la vie implique du courage, soit elle cesse d’être la vie.'
  },
  {
    source: 'Ellen DeGeneres',
    text:
      'J’ai appris la compassion après avoir été victime de discrimination. Tout ce qui m’est arrivé de mal m’a appris la compassion.'
  },
  {
    source: 'James Cameron',
    text:
      'Si vous définissez des objectifs trop élevés mais que c’est un échec, vous échouerez au moins au-dessus du succès de tout le monde.'
  },
  {
    source: 'Mandy Hale',
    text:
      'Soyez assez audacieux pour vivre votre vie selon vos propres termes et ne vous en excusez jamais.'
  },
  {
    source: 'Debbi Fields',
    text: 'Il est dur d’échouer; mais il est pire de n’avoir jamais tenté de réussir.'
  },
  {
    source: 'Elizabeth Barrett Browning',
    text: 'Ne mesurez le travail qu’une fois la journée terminée, et l’ouvrage accompli.'
  },
  {
    source: 'Ingvar Kamprad',
    text:
      'Faire des erreurs est le privilège de la personne active. Ce sont toujours les gens médiocres qui sont négatifs, qui passent leur temps à prouver qu’ils n’ont pas tort.'
  },
  {
    source: 'Leo Tolsto',
    ttext: 'Chacun rêve de changer l’humanité, mais personne ne pense à se changer soi-même.'
  },
  {
    source: 'Aldous Huxley',
    text: 'Il n’y a qu’un coin de l’univers que vous pouvez améliorer : c’est vous-même !'
  },
  {
    source: 'Theodore Thornton Munger',
    text: 'Rien n’est plus courant que des hommes de grand talent qui ne réussissent pas.'
  },
  {
    source: 'Steve Jobs',
    text:
      'Je suis convaincu que ce qui sépare la moitié des entrepreneurs qui réussissent de ceux qui échouent est purement la persévérance.'
  },
  {
    source: 'Dwight D. Eisenhower',
    text: 'Les plans ne sont rien; c’est la planification qui compte.'
  },
  {
    source: 'Booker T. Washington',
    text:
      'Il y a deux façons d’exercer sa force : l’une est de pousser vers le bas, l’autre de tirer vers le haut.'
  },
  {
    source: 'James Thurber',
    text:
      'Ne regardons jamais en arrière avec colère, ou en avant avec peur, mais autour de nous avec attention.'
  },
  {
    source: 'Nelson Mandela',
    text: 'Que vos choix soient le reflet de vos espoirs et non de vos peurs.'
  },
  {
    source: 'Steve Jobs',
    text: 'Certaines choses ne doivent pas nécessairement changer le monde pour être importantes.'
  },
  {
    source: 'Albert Einstein',
    text:
      'La paix ne peut être maintenue par la force; cela ne peut être réalisé que par la compréhension.'
  },
  {
    source: 'Frederick Douglass',
    text: 'L’âme qui est en moi, aucun homme ne peut la dégrader.'
  },
  {
    source: 'Peter Drucker',
    text: 'La chose la plus importante en communication, c’est d’entendre ce qui n’est pas dit.'
  },
  {
    source: 'Molière',
    text:
      'C’est un merveilleux assaisonnement aux plaisirs qu’on goûte que la présence des gens qu’on aime.'
  },
  {
    source: 'William Feather',
    text: 'Quiconque profite de la vie a réussi.'
  },
  {
    source: 'Pablo Picasso',
    text:
      'Apprenez les règles comme un professionnel afin de pouvoir les briser en tant qu’artiste.'
  },
  {
    source: 'Ursula Le Guin',
    text:
      'Il est peut-être agréable qu’un voyage prenne fin mais, finalement, c’est le voyage qui compte.'
  },
  {
    source: 'John F. Kennedy',
    text: 'La conformité est la geôlière de la liberté et l’ennemie de la croissance.'
  },
  {
    source: 'Robert Anthony',
    text: 'Certaines personnes boivent à la fontaine de la connaissance, d’autres se gargarisent.'
  },
  {
    source: 'Ralph Waldo Emerson',
    text: 'Chaque artiste a d’abord été un amateur.'
  },
  {
    source: 'Samuel Butler',
    text:
      'Tous les animaux, sauf l’être humain, savent que la chose essentielle, dans la vie, c’est d’en profiter. '
  },
  {
    source: 'Bruce Lee',
    text:
      'Absorbe ce qui est utile, rejette ce qui est inutile, et ajoute ce qui t’appartient en propre.'
  },
  {
    source: 'Earl Nightingale',
    text: 'Nos devenons ce que nous pensons.'
  },
  {
    source: 'Theodore Vail',
    text:
      'Les vraies difficultés peuvent être surmontées; ce ne sont que les imaginaires qui ne le sont pas. '
  },
  {
    source: 'Washington Irving',
    text: 'Les grands esprits ont un but, les autres ont de l’espoir.'
  },
  {
    source: 'Arnold Bennett',
    text:
      'Tout changement, même pour le mieux, s’accompagne toujours d’inconvénients et d’inconforts.'
  },
  {
    source: 'Dhirubhai Ambani',
    text:
      'Si tu ne construis pas ton propre rêve quelqu’un va t’embaucher pour te faire construire les siens.'
  },
  {
    source: 'Mario Andretti',
    text: 'Si tout semble sous contrôle, c’est que vous n’allez pas assez vite.'
  },
  {
    source: 'Oprah Winfrey',
    text: 'Already translated'
  },
  {
    source: 'Helen Keller',
    text:
      'À la longue, il n’est pas plus sûr d’éviter le danger que de s’y exposer. Les peureux se font prendre aussi souvent que les audacieux.'
  },
  {
    source: 'Thomas Paine',
    text: 'Plus dur le conflit, plus glorieuse la victoire.'
  },
  {
    source: 'Frank Tyger',
    text:
      'L’ennui avec les conseils, c’est qu’il faut d’abord les suivre pour savoir ce qu’ils valent.'
  },
  {
    source: 'Phyllis Theroux',
    text: 'Les erreurs sont le pont habituel entre l’inexpérience et la sagesse.'
  },
  {
    source: 'Gaylord Nelson',
    text:
      'Le test ultime pour la conscience de l’être humain peut être sa volonté de sacrifier quelque chose aujourd’hui pour les générations futures dont il n’entendera pas les paroles de remerciement.'
  },
  {
    source: 'Sarah Grand',
    text:
      'Notre opinion sur les gens dépend moins de ce que nous voyons en eux que de ce qu’ils nous font voir en nous-mêmes.'
  },
  {
    source: 'George Santayana',
    text:
      'Il n’y a aucun remède contre la naissance et la mort, sinon de profiter de la période qui les sépare.'
  },
  {
    source: 'Margaret Chase Smith',
    text:
      'Quand les gens ne cessent de vous dire que vous ne pouvez rien faire, ils vous tentent d’essayer.'
  },
  {
    source: 'André Gide',
    text: 'Croyez ceux qui cherhent la vérité, doutez de ceux qui la trouvent.'
  },
  {
    source: 'Frank Yerby',
    text: 'La maturité est atteinte le jour où nous n’avons plus besoin de vivre dans le mensonge.'
  },
  {
    source: 'Charles Dickens',
    text: 'Dans le monde, personne n’est inutile s’il allège le poids des autres. '
  },
  {
    source: 'Mary Browne',
    ttext:
      'Attendez-vous à ce que les gens soient meilleurs qu’ils ne le sont; cela les aide à devenir meilleurs. Mais ne soyez pas déçu quand ils ne le sont pas; cela les aide à continuer d’essayer.'
  },
  {
    source: 'Doug Larson',
    text:
      'Être sage, c’est éviter de se retrouver dans des situations qui feraient de la sagesse une nécessité. '
  },
  {
    source: 'Laozi',
    text:
      'Pour avoir de la connaissance, ajoutez des choses chaque jour. Pour avoir de la sagesse, enlevez des choses chaque jour.'
  }
]
